export default {
    apiGetOfflineAssessmentSections(data) {
        return this.request(this.api().getOfflineAssessmentSections, data)
            .exec()
            .log()
            .mapresults((response) => {
                let records = response?.data?.records || [];
                return {
                    data: records,
                    total: response?.data?.totalCount || 0,
                };
            })
            .get();
    },
    apiGetOfflineAssessmentSectionById(data) {
        return this.request(this.api().getOfflineAssessmentSectionById, {})
            .urltransform(data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetOfflineAssessmentParameters() {
        return this.request(this.api().getOfflineAssessmentParameters, {})
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiUpdateOfflineAssessmentSectionMarks(data, payload) {
        return this.request(this.api().updateOfflineAssessmentSectionMarks, payload)
            .urltransform(data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGenerateOfflineAssessmentReport(data, payload) {
        return this.request(this.api().generateOfflineAssessmentReport, payload)
            .urltransform(data)
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiDownloadOfflineAssessmentSectionExcel(data) {
        return this.request(this.api().downloadOfflineAssessmentSectionExcel, {})
            .urltransform(data)
            .responsetype("blob")
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiDownloadOfflineAssessmentSectionReport(data, params = {}) {
        return this.request(this.api().downloadOfflineAssessmentSectionReport, params)
            .urltransform(data)
            .responsetype("blob")
            .exec()
            .log()
            .mapresults((response) => response)
            .get();
    },
    apiGetSchoolList() {
        return this.request(this.api().getSchoolList, {})
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetAllSchoolListForCoordinator() {
        return this.request(this.api().getAllSchoolListForCoordinator, {})
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    },
    apiGetClassBySchool(params) {
        return this.request(this.api().getClassBySchool, {})
            .urltransform(params)
            .exec()
            .log()
            .mapresults((res) => res)
            .get();
    }
}
